import { defaultDeploymentDurationData } from '../../../../backend/config/classifiers/defaults/DefaultDeploymentDurationData';
import { deploymentDurationSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const deploymentDurationEntityName = 'deploymentDuration';
const deploymentDurationColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { durationLength: {
        type: 'number-required',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineDeploymentDurationClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: deploymentDurationColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { durationLength: params.data.durationLength, search: [params.data.name, params.data.status, params.data.durationLength].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultDeploymentDurationData,
        publicData: [
            {
                listRequest: {
                    filter: [{ column: 'status', op: '=', value: 'active' }],
                    orderBy: [{ column: 'durationLength' }, { column: 'name' }],
                },
            },
        ],
    }, deploymentDurationSchema);
}
